import { I18nNamespace } from '@/lib/i18n-namespaces';
import { CircleNotchIcon } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Badge } from '../Badge';

export function GeneratingPreviewBadge() {
    const { t } = useTranslation(I18nNamespace.SOURCES);
    return (
        <Badge variant="pending">
            <CircleNotchIcon size={16} className="animate-spin" />
            <span className="text-xs-medium">
                {t('card.generatingPreview')}
            </span>
        </Badge>
    );
}
